import * as React from "react";
import styled, { css } from "styled-components";
import { Link } from "components/common/router";
import { NAV_ITEM_HEIGHT } from "theme/constants";
import useActivePerspective from "components/perspectives/hooks/useActivePerspective";
const BrandContainer = styled.div`
  display: flex;
  align-items: center;
`;
const BrandLink = styled(Link)(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    min-height: ${NAV_ITEM_HEIGHT};
    color: ${theme.colors.text.primary};

    &:hover,
    &:active,
    &:focus {
      text-decoration: none;
      color: ${theme.colors.text.primary};
    }
  `
);
const ActivePerspectiveBrand = ({
  children = void 0,
  className = ""
}) => {
  const { activePerspective } = useActivePerspective();
  const ActiveBrandComponent = activePerspective == null ? void 0 : activePerspective.brandComponent;
  if (!ActiveBrandComponent) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(BrandContainer, { className }, /* @__PURE__ */ React.createElement(BrandLink, { to: activePerspective.welcomeRoute }, /* @__PURE__ */ React.createElement(ActiveBrandComponent, null)), children);
};
export default ActivePerspectiveBrand;
